import { Card } from '@sandtech-hub-monorepo/ui-kit';
import { usePlatforms } from '@sandtech-hub-monorepo/ui-kit-site';
import { ReactComponent as PaymentsIcon } from '../../../assets/Icons/payments-icon.svg';
import { AtSign } from 'lucide-react';
import { Link } from 'react-router-dom';

export const AssistanceSection = () => {
  const rootDomain = process.env['NX_COOKIE_DOMAIN'] || '';
  const { current } = usePlatforms(rootDomain);
  const paymentsApp = current.apps.find((app) => app.name === 'Payments');
  const supportApp = current.apps.find((app) => app.name === 'Support');

  return (
    <Card className="border-heading">
      <div className="flex flex-wrap">
        {/* Payment */}
        <div className="flex-1 min-w-[280px] flex items-center gap-6 p-6 md:p-9">
          <div className="shrink-0 w-[109px] h-[109px] rounded-full bg-heading/20 flex items-center justify-center">
            <PaymentsIcon className="w-[54px] h-[54px] text-heading" />
          </div>
          <div className="flex flex-col gap-1">
            <Link
              to={paymentsApp?.route || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              <h3 className="text-lg font-semibold text-heading">Payment</h3>
            </Link>
            <p className="text-base text-foreground/80">
              View your payments, see what's due, and track your billing
              history.
            </p>
          </div>
        </div>

        {/* Vertical Divider */}
        <div className="hidden md:block w-px bg-border self-stretch my-6" />

        {/* Support */}
        <div className="flex-1 min-w-[280px] flex items-center gap-6 p-6 md:p-9">
          <div className="shrink-0 w-[109px] h-[109px] rounded-full bg-heading/20 flex items-center justify-center">
            <AtSign
              className="w-[54px] h-[54px] text-heading"
              strokeWidth={1.25}
            />
          </div>
          <div className="flex flex-col gap-1">
            <Link
              to={supportApp?.route || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              <h3 className="text-lg font-semibold text-heading">Support</h3>
            </Link>
            <p className="text-base text-foreground/80">
              Email our team for help with your course, enrollment, or payments.
            </p>
          </div>
        </div>
      </div>
    </Card>
  );
};
